import { useState } from "react";
import deleteIcon from "../assets/images/delete.png";
import {
  addTemporaryProject,
  addTemporaryProjectTasks,
  saveProjectCheckList,
} from "../API";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const AddTempProjectModal = (props) => {
  const { virtualId, getTimeSheetWeekDetails, timeSheetDetails, type } = props;
  const [description, setDescription] = useState("");
  const [tasks, setTasks] = useState([
    {
      id: 0,
      description: "",
    },
  ]);

  const navigate = useNavigate();

  //   const onInputChange = (e) => {
  //     const id = parseInt(e.target.id);
  //     const value = e.target.value;
  //     setTasks((prevState) => {
  //       const filteredTasks = prevState?.filter((task) => task.id !== id);
  //       return [...filteredTasks, { id, description: value }];
  //     });
  //   };

  const resetFields = () => {
    setDescription("");
    setTasks([
      {
        id: 0,
        description: "",
      },
    ]);
  };

  const onInputChange = (e) => {
    const name = e.target.name;
    if (name === "description") {
      setDescription(e.target.value);
    } else if (name === "task") {
      const id = parseInt(e.target.id);
      const value = e.target.value;
      setTasks((prevTasks) =>
        prevTasks.map((task) =>
          task.id === id ? { ...task, description: value } : task
        )
      );
    }
  };

  const onClickAddTask = () => {
    const id = tasks[tasks.length - 1]?.id + 1;
    setTasks((prevTask) => [...prevTask, { id, description: "" }]);
  };

  const onDeleteClick = (id) => {
    setTasks((prevTasks) => prevTasks.filter((task) => task.id !== id));
  };

  const onClickSubmit = async () => {
    if (description && tasks[0].description) {
      const payload = {
        name: `TEMP-${virtualId}`,
        description,
        status: "Active",
        is_hold: false,
        type: "webtime",
      };

      await addTemporaryProject(payload)
        .then(async (res) => {
          if (res.status === 200) {
            const addProjectTaskRes = tasks?.map((task) => {
              const taskPayload = {
                external_id: "",
                description: task?.description,
                project_id: res?.data?.id,
                status: "Active",
              };
              return addTemporaryProjectTasks(taskPayload);
            });
            await Promise.all(addProjectTaskRes);

            // Adding checklist for the temp project
            if (type !== "timecard") {
              const payload = {
                project_id: res?.data?.id,
                pole_number: "",
                kv: 0,
                access: "",
                status: 0,
              };
              try {
                await saveProjectCheckList(payload).then((res) => {
                  if (res?.status === 200) {
                    toast.success("Checklist Added Successfully");
                    navigate(`/unit-job/${res?.data?.id}`);
                  } else {
                    navigate(`/project-checklist`);
                    toast.error("Failed to add checklist");
                  }
                });
              } catch (error) {
                toast.error("Failed to add checklist");
              }
            }
            toast.success("Project & tasks added");
            if (type === "timecard") {
              getTimeSheetWeekDetails(timeSheetDetails);
            }
            resetFields();
          } else {
            toast.error("Unable to add project & tasks");
            resetFields();
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          resetFields();
        });
    } else {
      toast.warning("Please enter the required fields");
    }
  };

  return (
    <>
      <div
        className="modal fade add-new-timesheet-modal"
        id="addNewTempProject"
        tabIndex="-1"
        aria-labelledby="addNewTempProjectLabel"
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5
                className="modal-title font-weight-bold"
                id="addNewTempProjectLabel"
              >
                Add new project
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => resetFields()}
              ></button>
            </div>
            <div className="modal-body">
              <div className="checklist-modal-field">
                <label htmlFor="temp-project-description" className="checklist-modal-label">
                  Project description *
                </label>
                <input
                  id="temp-project-description"
                  value={description}
                  name="description"
                  onChange={(e) => onInputChange(e)}
                  className="form-control checklist-modal-input"
                  type="text"
                  placeholder="Enter project description"
                />
              </div>
              <div className="checklist-modal-field">
                <div className="checklist-modal-field-head">
                  <label htmlFor="" className="checklist-modal-label">
                    Tasks *
                  </label>
                  <button
                    type="button"
                    onClick={() => onClickAddTask()}
                    className="add-sign"
                    title="Add another task"
                  >
                    +
                  </button>
                </div>
                <div className="add-task-scroll">
                  {tasks?.length > 0 &&
                    tasks?.map((task) => {
                      return (
                        <div className="task-input-add-btn-container" key={task?.id}>
                          <input
                            name="task"
                            id={task?.id}
                            value={task?.description}
                            onChange={(e) => onInputChange(e)}
                            className="input-w-85 form-control checklist-modal-input"
                            type="text"
                            placeholder="Enter task description"
                          />
                          {tasks?.length > 1 && (
                            <img
                              src={deleteIcon}
                              alt="Remove task"
                              style={{ cursor: "pointer" }}
                              className="img-fluid"
                              onClick={() => onDeleteClick(task?.id)}
                            />
                          )}
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                data-bs-dismiss="modal"
                type="button"
                className="primary-btn"
                aria-label="Close"
                onClick={() => onClickSubmit()}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddTempProjectModal;
